import Box from '@hlibs/react-web/components/Box';

const Background = (props) => <Box {...props}/>;

export default Background;
